const fireselectorRoot = document.querySelector("[data-fireselector]");
const rawSolutions = window.FIREDEFEND_SOLUTIONS || [];

const fields = {
  element: "Brandwerend element",
  elementType: "Type element",
  ei: "Brandweerstandsklasse EI",
  position: "Penetratiepositie",
  serviceType: "Type service",
  service: "Service",
  insulation: "Isolatie",
  diameter: "Buis-/kabeldiameter",
  product: "Product",
};

const sidebarLabels = {
  element: "Brandwerend element",
  elementType: "Type element",
  ei: "Brandweerstandsklasse EI",
  position: "Penetratiepositie",
  serviceType: "Type service",
  service: "Service",
  insulation: "Isolatie",
  diameter: "Buis-/kabeldiameter",
  product: "Product",
};

const modeLabels = {
  construction: "Op basis van constructie",
  product: "Op basis van product",
};

const productUrls = {
  "INTU FR COAT I": "/products/intu-fr-coat-i-brandvertragende-coating",
  "INTU FR COLLAR": "/products/intu-fr-collar-brandmanchet",
  "INTU FR COLLAR L SLIM": "/products/intu-fr-collar-l-slim-brandwerende-kraag",
  "INTU FR COLLAR ST": "/products/intu-fr-collar-brandmanchet",
  "INTU FR DISC": "/products/intu-fr-disc-brandwerende-bescherming-voor-doorvoeringen",
  "INTU FR FOAM 2K": "/products/intu-fr-foam-2k-brandwerend-schuim",
  "INTU FR GRAPHITE": "/products/intu-fr-graphite-brandwerende-grafietkit",
  "INTU FR GRILLE": "/products/intu-fr-grille-brandwerend-rooster",
  "INTU FR MASTIC": "/products/intu-fr-mastic-brandwerende-acrylaatkit",
  "INTU FR MORTAR": "/products/intu-fr-mortar-brandwerende-mortel",
  "INTU FR PUTTY CORD": "/products/intu-fr-putty-cord-brandwerend-afdichtingskoord",
  "INTU FR PUTTY PAD": "/products/intu-fr-putty-pad-brandwerende-pad",
  "INTU FR UNIBOARD": "/products/intu-fr-uniboard-brandwerende-steenwolplaat",
  "INTU FR UNICOAT P": "/products/intu-fr-unicoat-p-brandwerende-verf",
  "INTU FR WRAP": "/products/intu-fr-wrap-brandwerende-bescherming",
  "INTU FR WRAP L": "/products/intu-fr-wrap-l-brandbeveiliging-voor-leidingen",
};

const tdsUrls = {
  "ALFA FIREGUARD 3": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/ALFA_FIREGUARD_3_TDS.pdf?v=1780323519",
  "INTU ATP": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_ATP_TDS.pdf?v=1780323520",
  "INTU FR BANDAGE": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_BANDAGE_TDS.pdf?v=1780323520",
  "INTU FR BRICK": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_BRICK_TDS.pdf?v=1780323521",
  "INTU FR BUTTERFLY DAMPER KTB-O": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU-BUTTERFLY-DAMPER-KTB-O-TDS.pdf?v=1776330265",
  "INTU FR COAT I": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_COAT_I_TDS.pdf?v=1780323521",
  "INTU FR COLLAR": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_COLLAR_ST_TDS.pdf?v=1780323521",
  "INTU FR COLLAR ST": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_COLLAR_ST_TDS.pdf?v=1780323521",
  "INTU FR COLLAR L SLIM": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_COLLAR_L_SLIM_TDS.pdf?v=1780323702",
  "INTU FR DISC": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_DISC_TDS.pdf?v=1780323917",
  "INTU FR FOAM 2K": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_FOAM_2K_TDS.pdf?v=1780323522",
  "INTU FR GRAPHITE": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_GRAPHITE_TDS.pdf?v=1780323918",
  "INTU FR GRILLE": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_GRILLE_TDS.pdf?v=1780323919",
  "INTU FR GRILLE DS": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_GRILLE_DS_TDS.pdf?v=1780323519",
  "INTU FR MASTIC": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_MASTIC_TDS.pdf?v=1780323917",
  "INTU FR MORTAR": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_MORTAR_TDS.pdf?v=1780323520",
  "INTU FR PUTTY CORD": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_PUTTY_CORD_TDS.pdf?v=1780323521",
  "INTU FR PUTTY PAD": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_PUTTY_PAD_TDS.pdf?v=1780323520",
  "INTU FR ROPE": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_ROPE_TDS.pdf?v=1780323519",
  "INTU FR UNIBOARD": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_UNIBOARD_TDS.pdf?v=1780323921",
  "INTU FR UNICOAT P": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_UNICOAT_P_TDS.pdf?v=1780323918",
  "INTU FR WRAP": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_WRAP_TDS.pdf?v=1780323918",
  "INTU FR WRAP L": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_FR_WRAP_L_TDS.pdf?v=1780323919",
  "INTU STRIPE FC": "https://cdn.shopify.com/s/files/1/0794/1315/0020/files/INTU_STRIPE_FC_TDS.pdf?v=1780323518",
};

const productImages = window.FIREDEFEND_PRODUCT_IMAGES || {};
const solutionImages = window.FIREDEFEND_SOLUTION_IMAGES || {};
const detailIcons = window.FIREDEFEND_DETAIL_ICONS || {};
const optionImageRules = window.FIREDEFEND_OPTION_IMAGE_RULES || [];
const alfaFireguardImages = window.FIREDEFEND_ALFA_FIREGUARD_IMAGES || {};

const baseFieldOrder = {
  construction: ["element", "elementType", "ei", "position", "serviceType", "service", "insulation", "diameter", "product"],
  product: ["product", "element", "elementType", "ei", "position", "serviceType", "service", "insulation", "diameter"],
};
const luchtkanaalFieldOrder = ["element", "elementType", "product"];

const state = {
  mode: "construction",
  selections: {},
  activeIndex: -1,
  query: "",
  selectedSolutionIndex: null,
};

const optionGrid = fireselectorRoot.querySelector("#optionGrid");
const progressStrip = fireselectorRoot.querySelector("#progressStrip");
const stepSidebar = fireselectorRoot.querySelector("#stepSidebar");
const stepTitle = fireselectorRoot.querySelector("#stepTitle");
const stepCount = fireselectorRoot.querySelector("#stepCount");
const resultsPanel = fireselectorRoot.querySelector(".results-panel");
const freeSearch = fireselectorRoot.querySelector("#freeSearch");
const skipButton = fireselectorRoot.querySelector("#skipButton");
const previousStepButton = fireselectorRoot.querySelector("#previousStepButton");
const backButton = fireselectorRoot.querySelector("#backButton");
const modeGrid = fireselectorRoot.querySelector(".mode-grid");
const selectorHelp = fireselectorRoot.querySelector("#selectorHelp");

const normalize = (value) => String(value || "").trim();
const searchable = (value) => normalize(value).toLowerCase();
const diameterChoices = [32, 40, 55, 63, 75, 82, 90, 110, 125, 160, 200, 250, 315];

function diameterLabel(value) {
  return `${value}mm`;
}

function nearestDiameter(value) {
  return diameterChoices.find((choice) => value <= choice) || null;
}

function sentenceCase(value) {
  const text = normalize(value);
  if (!text || text === "-") return text;
  const lower = text.toLocaleLowerCase("nl-NL");
  const restored = lower
    .replace(/\bintu\b/g, "INTU")
    .replace(/\bfr\b/g, "FR")
    .replace(/\bei\b/g, "EI")
    .replace(/\bpp-r\b/g, "PP-R")
    .replace(/\bpe-hd\b/g, "PE-HD")
    .replace(/\bpe-xa\b/g, "PE-XA")
    .replace(/\bpex-al-pex\b/g, "PEX-AL-PEX")
    .replace(/\bpe-xb\/al\/pe-xb\b/g, "PE-XB/AL/PE-XB")
    .replace(/\bpvc\b/g, "PVC")
    .replace(/\bcpvc\b/g, "CPVC")
    .replace(/\babs\b/g, "ABS")
    .replace(/\bsan\b/g, "SAN")
    .replace(/\balupex\b/g, "ALUPEX")
    .replace(/\bfef\b/g, "FEF")
    .replace(/\bc\/u\b/g, "C/U")
    .replace(/\bu\/c\b/g, "U/C")
    .replace(/\bc\/c\b/g, "C/C");
  return restored.replace(/^(\s*)(\S)/, (match, spaces, first) => spaces + first.toLocaleUpperCase("nl-NL"));
}

function displayService(value) {
  const text = normalize(value);
  if (!text || text === "-") return text;
  const compact = text.replace(/\s/g, "");
  if (text.length <= 20 && /^[A-Z0-9Ø+\-/.,≤<>=]+$/.test(compact)) return text;
  return sentenceCase(text);
}

function displayValue(field, value) {
  const text = normalize(value);
  if (!text || text === "-") return text || "-";
  if (field === "product") return text;
  if (field === "service") return displayService(text);
  if (["diameter", "wallThickness", "testConfig", "ei"].includes(field)) return text;
  if (["info", "partitionFilling", "basedOn"].includes(field)) {
    return text.replace(/^(\s*)(\S)/, (match, spaces, first) => spaces + first.toLocaleUpperCase("nl-NL"));
  }
  return sentenceCase(text);
}

function splitValues(value) {
  const text = normalize(value);
  if (!text) return [];
  const parts = [];
  let start = 0;
  for (let index = 0; index < text.length; index += 1) {
    if (text[index] !== ",") continue;
    const before = text[index - 1] || "";
    const after = text[index + 1] || "";
    if (/\d/.test(before) && /\d/.test(after)) continue;
    parts.push(text.slice(start, index).trim());
    start = index + 1;
  }
  parts.push(text.slice(start).trim());
  return parts.filter(Boolean);
}

function numbersIn(value) {
  return normalize(value)
    .replace(/,/g, ".")
    .match(/\d+(\.\d+)?/g)
    ?.map((number) => Number.parseFloat(number))
    .filter(Number.isFinite) || [];
}

function diameterOptionsForRow(value) {
  const text = normalize(value);
  if (!text) return [];

  const options = new Set();
  const dnMatches = [...text.matchAll(/\bDN\s*(\d+)\b/gi)];
  dnMatches.forEach((match) => {
    const mapped = nearestDiameter(Number.parseFloat(match[1]));
    if (mapped) options.add(diameterLabel(mapped));
  });

  const segments = text.split(/[;|]/).map((segment) => segment.trim()).filter(Boolean);
  segments.forEach((segment) => {
    const cleanSegment = segment.replace(/,/g, ".");
    const rangeMatch = cleanSegment.match(/(\d+(?:\.\d+)?)\s*<\s*(?:\u00d8|\u00f8|diameter)?\s*\u2264\s*(\d+(?:\.\d+)?)/i);
    if (rangeMatch) {
      const mapped = nearestDiameter(Number.parseFloat(rangeMatch[2]));
      if (mapped) options.add(diameterLabel(mapped));
      return;
    }

    const maxMatch = cleanSegment.match(/(?:\u00d8|\u00f8|diameter|bundel|kabel)?\s*\u2264\s*(\d+(?:\.\d+)?)/i);
    if (maxMatch) {
      const mapped = nearestDiameter(Number.parseFloat(maxMatch[1]));
      if (!mapped) return;
      diameterChoices
        .filter((choice) => choice <= mapped)
        .forEach((choice) => options.add(diameterLabel(choice)));
      return;
    }

    numbersIn(segment).forEach((number) => {
      const mapped = nearestDiameter(number);
      if (mapped) options.add(diameterLabel(mapped));
    });
  });

  return [...options];
}

function valuesForField(field, value) {
  return field === "diameter" ? diameterOptionsForRow(value) : splitValues(value);
}

function elementTypeKind(value) {
  const text = searchable(value);
  if (text.includes("flexibele wand")) return "flexibele wand";
  if (text.includes("massieve wand")) return "massieve wand";
  if (text.includes("massieve vloer")) return "massieve vloer";
  if (text.includes("vloer")) return "vloer";
  return "";
}

function minimumThickness(value) {
  const text = normalize(value).replace(",", ".");
  const match = text.match(/(?:≥|>=|>)\s*(\d+(?:\.\d+)?)\s*mm/i);
  return match ? Number.parseFloat(match[1]) : Number.NaN;
}

function elementTypeMatches(rowValue, selectedValue) {
  const selectedKind = elementTypeKind(selectedValue);
  const selectedThickness = minimumThickness(selectedValue);
  if (!selectedKind || !Number.isFinite(selectedThickness)) return false;

  return splitValues(rowValue).some((part) => {
    if (elementTypeKind(part) !== selectedKind) return false;
    const requiredThickness = minimumThickness(part);
    return Number.isFinite(requiredThickness) && requiredThickness <= selectedThickness;
  });
}

function valueMatches(rowValue, selectedValue, field) {
  if (!selectedValue) return true;
  if (field === "ei") {
    const selectedEi = Number.parseFloat(String(selectedValue).replace(",", "."));
    const rowEi = Number.parseFloat(String(rowValue).replace(",", "."));
    if (Number.isFinite(selectedEi) && Number.isFinite(rowEi)) return rowEi >= selectedEi;
  }
  if (field === "diameter") {
    return diameterOptionsForRow(rowValue).includes(selectedValue);
  }
  if (field === "elementType" && elementTypeMatches(rowValue, selectedValue)) {
    return true;
  }
  const parts = splitValues(rowValue);
  return parts.length ? parts.includes(selectedValue) : normalize(rowValue) === selectedValue;
}

function getOrder() {
  return currentBaseOrder().filter((field) => hasRelevantField(field));
}

function currentBaseOrder() {
  if (state.mode === "construction" && searchable(state.selections.element) === "luchtkanaal") {
    return luchtkanaalFieldOrder;
  }
  return baseFieldOrder[state.mode];
}

function hasRelevantField(targetField) {
  const order = currentBaseOrder();
  const targetIndex = order.indexOf(targetField);

  return rawSolutions.some((row) => {
    const previousFieldsMatch = order.every((field, index) => {
      if (index >= targetIndex) return true;
      return valueMatches(row[field], state.selections[field], field);
    });
    return previousFieldsMatch && valuesForField(targetField, row[targetField]).length > 0;
  });
}

function matchesSelections(row, uptoIndex = Infinity, order = getOrder()) {
  return order.every((field, index) => {
    if (index > uptoIndex) return true;
    return valueMatches(row[field], state.selections[field], field);
  });
}

function filteredRows(uptoIndex = Infinity) {
  const order = getOrder();
  const terms = searchable(state.query)
    .split(/\s+/)
    .filter(Boolean);

  return rawSolutions.filter((row) => {
    if (!matchesSelections(row, uptoIndex, order)) return false;
    if (!terms.length) return true;
    const haystack = searchable(Object.values(row).join(" "));
    return terms.every((term) => haystack.includes(term));
  });
}

function optionsFor(field) {
  const rows = filteredRows(state.activeIndex - 1);
  const values = new Set();
  rows.forEach((row) => {
    valuesForField(field, row[field]).forEach((value) => {
      values.add(value);
    });
  });

  return [...values].sort((a, b) => sortOption(field, a, b));
}

function sortOption(field, a, b) {
  if (field === "ei" || field === "diameter") {
    const numberA = firstNumber(a);
    const numberB = firstNumber(b);
    if (Number.isFinite(numberA) && Number.isFinite(numberB)) return numberA - numberB;
  }
  return a.localeCompare(b, "nl", { numeric: true, sensitivity: "base" });
}

function firstNumber(value) {
  const match = normalize(value).replace(",", ".").match(/\d+(\.\d+)?/);
  return match ? Number.parseFloat(match[0]) : Number.NaN;
}

function selectOption(field, value) {
  const order = getOrder();
  const index = order.indexOf(field);
  state.selections[field] = value;
  state.selectedSolutionIndex = null;
  order.slice(index + 1).forEach((nextField) => delete state.selections[nextField]);
  const nextOrder = getOrder();
  const nextField = order.slice(index + 1).find((candidate) => nextOrder.includes(candidate));
  state.activeIndex = nextField ? nextOrder.indexOf(nextField) : nextOrder.length;
  render();
}

function skipStep() {
  const order = getOrder();
  state.selectedSolutionIndex = null;
  state.activeIndex = Math.min(state.activeIndex + 1, order.length);
  render();
}

function previousStep() {
  if (state.activeIndex < 0) return;
  if (state.activeIndex === 0) {
    state.activeIndex = -1;
    render();
    return;
  }
  const order = getOrder();
  const currentField = order[state.activeIndex];
  delete state.selections[currentField];
  state.selectedSolutionIndex = null;
  state.activeIndex -= 1;
  render();
}

function goToStep(stepIndex) {
  const order = getOrder();
  state.selectedSolutionIndex = null;
  if (stepIndex <= 0) {
    state.activeIndex = -1;
    state.selections = {};
    render();
    return;
  }

  const targetIndex = Math.min(stepIndex - 1, order.length);
  order.slice(targetIndex).forEach((field) => delete state.selections[field]);
  state.activeIndex = targetIndex;
  render();
}

function reset(mode = state.mode) {
  state.mode = mode;
  state.selections = {};
  state.activeIndex = -1;
  state.query = "";
  state.selectedSolutionIndex = null;
  freeSearch.value = "";
  fireselectorRoot.querySelectorAll(".mode-card").forEach((button) => {
    button.classList.toggle("is-active", button.dataset.mode === mode);
  });
  render();
}

function renderProgress() {
  const order = getOrder();
  const steps = [
    { field: "search", label: "Stap 1" },
    ...order.map((field, index) => ({ field, label: `Stap ${index + 2}` })),
    { field: "solutions", label: "Oplossingen" },
  ];
  const activeStep = state.activeIndex + 1;
  progressStrip.innerHTML = steps
    .map(({ field, label }, index) => {
      const value = field === "search" ? modeLabels[state.mode] : displayValue(field, state.selections[field]);
      const isFilled = field !== "solutions" && index < activeStep;
      const isActive = index === activeStep;
      const isClickable = index <= activeStep && field !== "solutions";
      return `
        <button class="crumb ${isActive ? "is-active" : ""} ${isFilled ? "is-filled" : ""}" type="button" data-step-index="${index - 1}" ${isClickable ? "" : "disabled"}>
          ${escapeHtml(label)}
          ${value ? `<span class="crumb-value">${escapeHtml(value)}</span>` : ""}
        </button>
      `;
    })
    .join("");
}

function renderSidebar() {
  stepSidebar.hidden = state.activeIndex < 0;
  if (state.activeIndex < 0) {
    stepSidebar.innerHTML = "";
    return;
  }

  const order = getOrder();
  const rows = [
    { label: "Zoeken", value: state.activeIndex >= 0 ? modeLabels[state.mode] : "-", index: 1, active: state.activeIndex === -1 },
    ...order.map((field, index) => ({
      label: sidebarLabels[field],
      value: displayValue(field, state.selections[field]),
      index: index + 2,
      filled: Boolean(state.selections[field]),
      active: index === state.activeIndex,
      disabled: index > state.activeIndex,
    })),
  ];

  stepSidebar.innerHTML = rows
    .map((row) => {
      return `
        <button class="sidebar-step ${row.active ? "is-active" : ""}" type="button" data-step-index="${row.index - 2}" ${row.disabled ? "disabled" : ""}>
          <span>${row.index}. ${escapeHtml(row.label)}</span>
          <strong>${escapeHtml(row.value)}</strong>
        </button>
      `;
    })
    .join("");
}

function renderOptions() {
  modeGrid.hidden = state.activeIndex >= 0;

  if (state.activeIndex < 0) {
    stepCount.textContent = "Stap 1 van 10";
    stepTitle.textContent = "";
    skipButton.hidden = true;
    previousStepButton.hidden = true;
    optionGrid.classList.remove("is-solutions");
    optionGrid.innerHTML = "";
    return;
  }

  const order = getOrder();
  if (state.activeIndex >= order.length) {
    stepCount.textContent = "Oplossingen";
    stepTitle.textContent = "Oplossingen";
    skipButton.hidden = true;
    previousStepButton.hidden = state.selectedSolutionIndex !== null;
    optionGrid.classList.add("is-solutions");
    renderSolutionCards();
    return;
  }

  const field = order[state.activeIndex];
  const options = optionsFor(field);

  stepCount.textContent = `Stap ${state.activeIndex + 2} van ${order.length + 1}`;
  stepTitle.textContent = fields[field];
  optionGrid.classList.remove("is-solutions");
  skipButton.disabled = state.activeIndex >= order.length - 1;
  skipButton.hidden = state.activeIndex >= order.length - 1;
  previousStepButton.hidden = false;

  if (!options.length) {
    optionGrid.innerHTML = `<div class="empty-state">Geen opties gevonden binnen deze combinatie. Ga een stap terug of start opnieuw.</div>`;
    return;
  }

  optionGrid.innerHTML = options
    .map((value) => {
      const selected = state.selections[field] === value;
      const optionImage = optionImageFor(field, value);
      return `
        <button class="option-button ${selected ? "is-selected" : ""}" type="button" data-field="${field}" data-value="${escapeAttr(value)}">
          ${optionImage ? productImageMarkup(value, optionImage, "tile-product-image") : `<span class="tile-icon ${iconClassFor(field, value)}" aria-hidden="true"></span>`}
          <span class="tile-label">
          ${escapeHtml(formatOptionLabel(field, value))}
          </span>
        </button>
      `;
    })
    .join("");
}

function formatOptionLabel(field, value) {
  if (field === "ei" && /^\d+([,.]\d+)?$/.test(normalize(value))) return `${normalize(value)} minuten`;
  if (field === "diameter" && /^\d+mm$/i.test(normalize(value))) return normalize(value).toLowerCase();
  if (field === "diameter" && /^\d+([,.]\d+)?$/.test(normalize(value))) return `Ø ≤ ${normalize(value)} mm`;
  return displayValue(field, value);
}

function optionImageFor(field, value) {
  if (field === "product") return productImages[value] || "";
  const text = stripAccents(searchable(value));
  const alfaImage = alfaFireguardOptionImageFor(field, text);
  if (alfaImage) return alfaImage;
  const rule = optionImageRules.find((item) => {
    if (!item.fields.includes(field)) return false;
    return item.includes.some((needle) => !needle || text.includes(stripAccents(searchable(needle))));
  });
  return rule ? rule.src : "";
}

function alfaFireguardOptionImageFor(field, text) {
  if (state.selections.product !== "ALFA FIREGUARD 3") return "";
  const rectangleImage = alfaFireguardImages.rectangle || "";
  const roundImage = alfaFireguardImages.round || "";

  if (field === "position" && (text.includes("horizontaal kanaal") || text.includes("verticaal kanaal"))) {
    const service = stripAccents(searchable(state.selections.service));
    if (service.includes("rond")) return roundImage || rectangleImage;
    return rectangleImage || roundImage;
  }

  if (field === "serviceType" && text.includes("ventilatie")) {
    const service = stripAccents(searchable(state.selections.service));
    if (service.includes("rond")) return roundImage || rectangleImage;
    return rectangleImage || roundImage;
  }

  if (field === "service") {
    if (text.includes("rond ventilatiekanaal")) return roundImage || rectangleImage;
    if (text.includes("rechthoekig ventilatiekanaal")) return rectangleImage || roundImage;
  }

  return "";
}

function stripAccents(value) {
  return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

function canonicalImageProduct(product) {
  return product === "INTU FR COLLAR ST" ? "INTU FR COLLAR" : normalize(product);
}

function solutionImageFor(row) {
  const product = canonicalImageProduct(row.product);
  const images = solutionImages[product] || [];
  const productFallback = productImages[product] || productImages[row.product] || "";
  if (!images.length) return productFallback;

  const scored = images
    .map((src) => ({ src, score: solutionImageScore(src, row), incompatible: isIncompatibleWallImage(src, row) }));
  const best = scored
    .filter((image) => !image.incompatible)
    .sort((a, b) => b.score - a.score)[0];
  const overview = scored.find((image) => imageText(image.src).includes("product overzicht") && !image.incompatible);

  if (best && best.score > 0) return best.src;
  return overview?.src || productFallback;
}

function solutionImageScore(src, row) {
  const image = imageText(src);
  const context = imageContext(row);
  const element = stripAccents(searchable(row.element));
  let score = image.includes("product overzicht") ? -4 : 0;

  const add = (condition, points) => {
    if (condition) score += points;
  };

  add(image.includes("flexibele wand") && context.includes("flexibele wand"), 14);
  add(image.includes("massieve wand") && context.includes("massieve wand"), 14);
  add(image.includes("flexibele wand") && context.includes("massieve wand"), -50);
  add(image.includes("massieve wand") && context.includes("flexibele wand"), -50);
  add(image.includes("wand") && element.includes("wand"), 18);
  add(image.includes("vloer") && element.includes("vloer"), 18);
  add(element.includes("wand") && image.includes("vloer") && !image.includes("wand bij vloer"), -35);
  add(element.includes("vloer") && image.includes("wand") && !image.includes("wand bij vloer"), -35);
  add(image.includes("luchtkanaal") && (context.includes("luchtkanaal") || context.includes("ventilatiekanaal")), 15);
  add(image.includes("rechthoekig") && context.includes("rechthoekig"), 8);
  add(image.includes("rond") && context.includes("rond"), 8);
  add(image.includes("lineaire voeg") && context.includes("lineaire voeg"), 14);
  add(image.includes("voeg") && context.includes("voeg"), 8);
  add(image.includes("rooster") && context.includes("rooster"), 10);
  add(image.includes("kabelgoot") && context.includes("kabelgoot"), 12);
  add(image.includes("kabelbundel") && (context.includes("kabelbundel") || context.includes("bundel van kabel")), 12);
  add(image.includes("kabel") && context.includes("kabel"), 6);
  add(image.includes("gemengde doorvoering") && context.includes("gemengde doorvoering"), 12);
  add(image.includes("brandbare buis") && (context.includes("brandbare leiding") || context.includes("brandbare buis")), 12);
  add(image.includes("buis") && (context.includes("leiding") || context.includes("buis")), 5);
  add(image.includes("metalen") && context.includes("metalen"), 10);
  add(image.includes("onbrandbare") && context.includes("onbrandbare"), 10);
  add(image.includes("geisoleerde") && (context.includes("geisoleerde") || context.includes("geisoleerd") || context.includes("isolatie")), 10);
  add(image.includes("zonder isolatie") && (context.includes("zonder isolatie") || context.includes("geen isolatie")), 10);
  add(image.includes("bocht") && (context.includes("bocht") || context.includes("elbow")), 10);
  add(image.includes("schuin") && (context.includes("schuin") || context.includes("hoek")), 9);
  add(image.includes("een zijde") && (context.includes("eenzijdig") || context.includes("een zijde")), 7);
  add(image.includes("enkele zijde") && (context.includes("eenzijdig") || context.includes("enkele zijde")), 7);
  add(image.includes("dubbele zijde") && (context.includes("beide zijden") || context.includes("dubbele zijde")), 7);
  add(image.includes("pvc") && context.includes("pvc"), 7);
  add(/\bpp\b/.test(image) && /\bpp\b/.test(context), 7);
  add(/\bpe\b/.test(image) && /\bpe\b/.test(context), 7);

  const ei = normalize(row.ei);
  add(Boolean(ei) && image.includes(`ei ${ei}`), 9);

  return score;
}

function isIncompatibleWallImage(src, row) {
  const image = imageText(src);
  const context = imageContext(row);
  return (context.includes("massieve wand") && image.includes("flexibele wand"))
    || (context.includes("flexibele wand") && image.includes("massieve wand"));
}

function imageText(src) {
  return stripAccents(searchable(src.replace(/[_/.-]+/g, " ")));
}

function imageContext(row) {
  return stripAccents(searchable([
    row.element,
    row.elementType,
    row.position,
    row.serviceType,
    row.service,
    row.insulation,
    row.diameter,
    row.wallThickness,
    row.testConfig,
    row.info,
    row.partitionFilling,
    row.basedOn,
  ].join(" ")));
}

function renderSolutionCards() {
  const rows = filteredRows();
  if (!rows.length) {
    optionGrid.innerHTML = `<div class="empty-state">Geen oplossing gevonden. Controleer de combinatie of neem contact op voor projectspecifiek advies.</div>`;
    return;
  }

  if (state.selectedSolutionIndex !== null) {
    const selectedRow = rows[state.selectedSolutionIndex];
    if (selectedRow) {
      optionGrid.innerHTML = renderSolutionDetail(selectedRow);
      return;
    }
    state.selectedSolutionIndex = null;
  }

  optionGrid.innerHTML = rows.map((row, index) => renderResultCard(row, index)).join("");
}

function iconClassFor(field, value) {
  const text = searchable(value);
  if (field === "element") {
    if (text.includes("vloer")) return "icon-floor";
    if (text.includes("deur")) return "icon-door";
    if (text.includes("kanaal")) return "icon-duct";
    if (text.includes("voeg")) return "icon-joint";
    return "icon-wall";
  }
  if (field === "elementType") return text.includes("flex") ? "icon-flex-wall" : "icon-rigid-wall";
  if (field === "ei") return "icon-flame";
  if (field === "position") return text.includes("multiple") || text.includes("meer") ? "icon-multiple" : "icon-single";
  if (field === "serviceType" || field === "service") return "icon-pipe";
  if (field === "diameter") return "icon-diameter";
  if (field === "product") return "icon-product";
  return "icon-default";
}

function renderResultCard(row, index) {
  const productImage = solutionImageFor(row);

  return `
    <article class="result-card">
      ${productImage ? productImageMarkup(row.product, productImage, "result-product-image") : ""}
      <header>
        <h3>${escapeHtml(row.product || "Productadvies")}</h3>
        <p class="result-summary">${escapeHtml(displayValue("element", row.element))} &middot; EI ${escapeHtml(row.ei || "-")} &middot; ${escapeHtml(displayValue("serviceType", row.serviceType))}</p>
        <div class="meta">
          ${tag(`EI ${row.ei || "-"}`)}
          ${tag(displayValue("element", row.element))}
          ${tag(displayValue("serviceType", row.serviceType))}
        </div>
      </header>
      <dl class="result-details">
        ${detail("Element", row.elementType, "elementType")}
        ${detail("Positie", row.position, "position")}
        ${detail("Service", row.service, "service")}
        ${detail("Diameter", row.diameter, "diameter")}
        ${detail("Wanddikte", row.wallThickness, "wallThickness")}
        ${detail("Configuratie", row.testConfig, "testConfig")}
        ${detail("Plaatsing", row.info, "info")}
        ${detail("Vulling", row.partitionFilling, "partitionFilling")}
        ${detail("Onderbouwing", row.basedOn, "basedOn")}
      </dl>
      <button class="contact-link solution-detail-button" type="button" data-solution-index="${index}">Bekijk geschikte oplossing</button>
    </article>
  `;
}

function renderSolutionDetail(row) {
  const subject = encodeURIComponent(`Advies aanvraag: ${row.product || "Firedefend product"}`);
  const body = encodeURIComponent(`Graag ontvang ik advies over oplossing ${row.solution || ""} voor ${row.element || ""} / ${row.service || ""}.`);
  const productUrl = productUrls[row.product] || row.productUrl;
  const productImage = solutionImageFor(row);
  const tdsUrl = tdsUrls[row.product];
  const productAction = productUrl && row.productStatus !== "op aanvraag"
    ? `<a class="solution-primary-link" href="${escapeAttr(productUrl)}" target="_blank" rel="noopener">Bekijk product</a>`
    : `<a class="solution-primary-link" href="mailto:info@firedefend.nl?subject=${subject}&body=${body}">Vraag advies aan</a>`;
  const tdsIcon = detailIcons.tds ? `<img class="solution-action-image" src="${escapeAttr(detailIcons.tds)}" alt="" aria-hidden="true" loading="lazy" />` : "";
  const classificationIcon = detailIcons.classification ? `<img class="solution-action-image" src="${escapeAttr(detailIcons.classification)}" alt="" aria-hidden="true" loading="lazy" />` : "";
  const tdsAction = tdsUrl
    ? `<a class="solution-download" href="${escapeAttr(tdsUrl)}" target="_blank" rel="noopener">${tdsIcon}<span>Download TDS</span></a>`
    : `<span class="solution-download is-disabled">${tdsIcon}<span>TDS niet beschikbaar</span></span>`;

  return `
    <article class="solution-detail">
      <div class="solution-toolbar">
        <button class="text-button solution-back-button" type="button">Terug naar oplossingen</button>
      </div>
      <div class="solution-detail-grid">
        <div class="solution-visual-column">
          <div class="solution-visual">
            ${productImage ? productImageMarkup(row.product, productImage, "solution-product-image") : `<div class="solution-image-placeholder">Geen afbeelding beschikbaar</div>`}
          </div>
          ${helpPrompt()}
        </div>
        <div class="solution-content">
          <p class="step-count">Oplossing ${escapeHtml(row.solution || "")}</p>
          <h2>${escapeHtml(row.product || "Productadvies")}</h2>
          <p class="solution-subtitle">${escapeHtml(displayValue("serviceType", row.serviceType))}</p>
          <p class="solution-based">Geschikte oplossing op basis van ${escapeHtml(displayValue("basedOn", row.basedOn) || "beschikbare documentatie")}</p>
          <div class="solution-spec-list">${solutionSpecs(row)}</div>
          <p class="solution-note">Controleer altijd de actuele TDS en projectsituatie. Wandtype, vloertype, dikte, buismateriaal, diameter, isolatie, sparingsmaat en brandwerendheid kunnen invloed hebben.</p>
          <div class="solution-actions">
            <div class="solution-classification">
              ${classificationIcon}
              <span>Brandclassificatie<br />EI ${escapeHtml(row.ei || "-")} ${escapeHtml(row.testConfig || "")}</span>
            </div>
            ${tdsAction}
          </div>
          ${productAction}
        </div>
      </div>
    </article>
  `;
}

function solutionSpecs(row) {
  if (isLuchtkanaal(row)) {
    return [
      solutionSpec("1", "Type element", row.elementType, "elementType"),
      solutionSpec("2", "Kanaaltype", row.service, "service"),
      solutionSpec("", "Kanaalrichting", row.position, "position"),
      solutionSpec("", "Kanaalafmeting", row.diameter, "diameter"),
      solutionSpec("3", "Montage", row.partitionFilling, "partitionFilling"),
      solutionSpec("4", "Product", row.info, "info"),
    ].join("");
  }

  return [
    solutionSpec("1", "Type element", row.elementType, "elementType"),
    solutionSpec("2", "Service", row.service, "service"),
    solutionSpec("", "Buis-/kabeldiameter", row.diameter, "diameter"),
    solutionSpec("", "Wanddikte", row.wallThickness, "wallThickness"),
    solutionSpec("3", "Vulling", row.partitionFilling, "partitionFilling"),
    solutionSpec("4", "Product", row.info, "info"),
  ].join("");
}

function isLuchtkanaal(row) {
  return searchable(row.element).includes("luchtkanaal");
}

function solutionSpec(number, label, value, field) {
  if (!normalize(value)) return "";
  return `
    <div class="solution-spec">
      ${number ? `<span class="solution-spec-number">${escapeHtml(number)}</span>` : `<span></span>`}
      <strong>${escapeHtml(label)}</strong>
      <span>${escapeHtml(displayValue(field, value))}</span>
    </div>
  `;
}

function helpPrompt() {
  return `
    <a class="selector-help" href="mailto:info@firedefend.nl?subject=Ik%20zoek%20een%20Firedefend%20oplossing">
      <span class="selector-help-icon" aria-hidden="true">?</span>
      <span>Zoek je een oplossing maar kun je hem niet vinden?<br />Neem contact met ons op.</span>
    </a>
  `;
}

function productImageMarkup(product, src, className) {
  return `<img class="${className}" src="${escapeAttr(src)}" alt="${escapeAttr(product)}" loading="lazy" />`;
}

function tag(value) {
  return value ? `<span class="tag">${escapeHtml(value)}</span>` : "";
}

function detail(label, value, field) {
  if (!normalize(value)) return "";
  return `<div class="detail-row"><dt>${escapeHtml(label)}</dt><dd>${escapeHtml(displayValue(field, value))}</dd></div>`;
}

function escapeHtml(value) {
  return normalize(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

function escapeAttr(value) {
  return escapeHtml(value).replaceAll("`", "&#096;");
}

function render() {
  fireselectorRoot.classList.toggle("has-solution-detail", state.selectedSolutionIndex !== null);
  resultsPanel.hidden = true;
  renderProgress();
  renderSidebar();
  renderOptions();
  renderHelp();
}

function renderHelp() {
  if (!selectorHelp) return;
  const showGlobalHelp = state.selectedSolutionIndex === null;
  selectorHelp.hidden = !showGlobalHelp;
  selectorHelp.innerHTML = showGlobalHelp ? helpPrompt() : "";
}

fireselectorRoot.querySelectorAll(".mode-card").forEach((button) => {
  button.addEventListener("click", () => {
    state.mode = button.dataset.mode;
    state.selections = {};
    state.activeIndex = 0;
    state.selectedSolutionIndex = null;
    fireselectorRoot.querySelectorAll(".mode-card").forEach((modeButton) => {
      modeButton.classList.toggle("is-active", modeButton.dataset.mode === state.mode);
    });
    render();
  });
});

fireselectorRoot.querySelector("#resetButton").addEventListener("click", () => reset());
skipButton.addEventListener("click", skipStep);
previousStepButton.addEventListener("click", previousStep);
backButton.addEventListener("click", previousStep);

progressStrip.addEventListener("click", (event) => {
  const button = event.target.closest(".crumb");
  if (!button || button.disabled) return;
  goToStep(Number.parseInt(button.dataset.stepIndex, 10));
});

stepSidebar.addEventListener("click", (event) => {
  const button = event.target.closest(".sidebar-step");
  if (!button) return;
  goToStep(Number.parseInt(button.dataset.stepIndex, 10));
});

optionGrid.addEventListener("click", (event) => {
  const detailButton = event.target.closest(".solution-detail-button");
  if (detailButton) {
    state.selectedSolutionIndex = Number.parseInt(detailButton.dataset.solutionIndex, 10);
    render();
    return;
  }

  if (event.target.closest(".solution-back-button")) {
    state.selectedSolutionIndex = null;
    render();
    return;
  }

  const button = event.target.closest(".option-button");
  if (!button) return;
  selectOption(button.dataset.field, button.dataset.value);
});

freeSearch.addEventListener("input", (event) => {
  state.query = event.target.value;
  state.selectedSolutionIndex = null;
  if (state.activeIndex >= getOrder().length) renderOptions();
});

render();
